export default "__VITE_ASSET__8vVNALEs__"